import log, { authTokenExists } from "@fxid/shared";
import { fetchProfileData } from "./fetchProfileData";
/**
 * Асинхронно получает данные профиля пользователя. Возвращает undefined если токена нет
 */
export const fetchProfileDataIfAvailable = async (gameSystemName, forceRefetch = false) => {
    if (!authTokenExists()) {
        log.debug("No auth token for profile to get");
        return Promise.resolve(undefined);
    }
    return fetchProfileData(gameSystemName, forceRefetch);
};
//# sourceMappingURL=fetchProfileDataIfAvailable.js.map